import api from './api';

export default {
  getAccountsList(page, pageSize, orderby, search, terms, dates, fields) {
    fields = { ...fields };

    let params = {
      paginate: pageSize,
      page,
      orderby,
      search,
      terms,
      dates,
      fields
    };

    return new Promise((resolve, reject) => {
      api
        .get('account/search', { params })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },

  getAccount(id, fields) {
    return new Promise((resolve, reject) => {
      let params = {
        fields
      };
      api
        .get('account/find/' + id, { params })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },

  register(details) {
    return new Promise((resolve, reject) => {
      api
        .post('register', { details })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },

  update(id, updates) {
    return new Promise((resolve, reject) => {
      api
        .put(`account/${id}`, { updates })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },

  updateCampaign(updates) {
    return new Promise((resolve, reject) => {
      api
        .put(`campaign/${updates.id}`, { updates })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },

  addCampaign(updates) {
    return new Promise((resolve, reject) => {
      api
        .post(`campaign`, updates)
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  }
};
